import {Skeleton} from '@gwc/core'
import {Box, UnstableCard as Paper} from '@yandex-delivery/blocks'
import React, {memo} from 'react'

import {renderWidget} from '../../widgets'
import {WidgetType} from '../../widgets/types'
import {ActionButtonSkeleton} from './components/ActionButtonSkeleton'
import {BadgeSkeleton} from './components/BadgeSkeleton'
import {SlotSkeleton} from './components/SlotSkeleton'
import {VerticalsSkeleton} from './components/VerticalsSkeleton'
import * as classes from './LayoutSkeleton.classes'

// TODO: выпилить после переезда на мультиформу в проде и пересесть на index@mobile

export const LayoutSkeleton = memo(
  (): React.ReactElement => (
    <div className={classes.skeletonsWrapper}>
      <Paper className={classes.paper.header} radius="L" noOverflow>
        <Skeleton className={classes.skeleton.header.l} my="s" />
        <Skeleton className={classes.skeleton.tabs} mb="m" />
        <VerticalsSkeleton mb="m" />
        <Skeleton className={classes.skeleton.banner} />
      </Paper>
      <Paper radius="L" noOverflow>
        <Skeleton className={classes.skeleton.header.m} mb="m" />
        {renderWidget({widget_id: 'divider_line_margin_1', type: WidgetType.DIVIDER, style: 'line_margin'})}
        <SlotSkeleton size="l" />
        {renderWidget({widget_id: 'line_slot_margin_1', type: WidgetType.DIVIDER, style: 'line_slot_margin'})}
        <SlotSkeleton mb="m" size="l" />
        <Box>
          <BadgeSkeleton badgeSize="l" mr="xs" />
          <BadgeSkeleton badgeSize="s" />
        </Box>
      </Paper>
      <Paper radius="L" noOverflow>
        <Skeleton className={classes.skeleton.header.m} mb="m" />
        {renderWidget({widget_id: 'divider_line_margin_2', type: WidgetType.DIVIDER, style: 'line_margin'})}
        <Skeleton size="xl" style={{marginBlock: 12}} />
        {renderWidget({widget_id: 'divider_line_margin_3', type: WidgetType.DIVIDER, style: 'line_margin'})}
        <Skeleton size="xl" style={{marginBlock: 12}} />
      </Paper>
      <Paper className={classes.paper.banner} radius="L" noOverflow>
        <Skeleton className={classes.skeleton.banner} />
      </Paper>
      <Paper className={classes.paper.footer} radius="L" noOverflow>
        <SlotSkeleton className={classes.skeleton.paymentMethod} size="l" />
        <ActionButtonSkeleton />
      </Paper>
    </div>
  ),
)
